import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  body: Record<string, any>;
}

export function useLeadsProprios(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const LEAD_PROPRIOS = `${leadsWebEnviroment}/commom/leads/proprios/v2`;
    const response = await instance.post(LEAD_PROPRIOS, props.body);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
